function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React, {useMemo} from "react";
import * as FaFontIcons from "../../../../__snowpack__/pkg/react-icons/fa.js";
import {cmpClassName, execFn, parseSize} from "../../../common/generic-react.functions.js";
import {IconContainer} from "./icon.styles.js";
function Icon({
  name,
  size = "base",
  color = "inherit",
  title,
  href,
  hidden,
  onClick,
  ...otherProperties
}) {
  const faName = useMemo(() => name && "Fa" + name.split("-").map((n) => n[0].toUpperCase() + n.slice(1)).join(""), [name]);
  const iconSize = useMemo(() => +parseSize(size, true), [size]);
  const iconProps = useMemo(() => ({
    color,
    title,
    className: "react-icon"
  }), [color, title]);
  const iconSpan = useMemo(() => name ? /* @__PURE__ */ React.createElement(FaFontIcons[faName.toString()], iconProps) : null, [faName, iconProps, name]);
  const realSize = useMemo(() => typeof size === "string" ? iconSize : size, [iconSize, size]);
  return /* @__PURE__ */ React.createElement(IconContainer, _extends({
    className: cmpClassName("icon")
  }, otherProperties, {
    "aria-hidden": true,
    size: realSize,
    clickable: !!onClick || !!href,
    hidden,
    onClick: () => execFn(onClick, name)
  }), href ? /* @__PURE__ */ React.createElement("a", {
    href
  }, iconSpan) : iconSpan);
}
export default /* @__PURE__ */ React.memo(Icon);
